/* KINSŌ — la landing del Test A/B en DESKTOP (19/9/2026). Solo en el tema "Test A/B".

   La landing se armó para el celular (97,6% del tráfico según Clarity) y en desktop se
   rompía entera:
   - la galería estaba forzada a 100vw (regla "fullbleed" de p9TE4L) y con el diseño
     "apilado" del tema: las 7 fotos una abajo de otra a pantalla completa, ~10.000 px
     antes de llegar a los packs;
   - todo el resto de la landing vive ADENTRO de la columna de compra (445 px, pegada a
     la izquierda), y las secciones "a sangre" calculaban el ancho desde esa columna, así
     que quedaban corridas 277 px a la izquierda y cortadas.

   Arreglo, sin mover nodos (los bloques de la landing se buscan entre sí por id y montan
   tarde): de 990 px para arriba, el .product pasa a ser una grilla de dos columnas y la
   columna de compra se "disuelve" (display:contents), así que sus hijos quedan como
   celdas de esa grilla. La zona de compra (título, beneficios, packs, botones, tarjeta ML,
   garantía y preguntas) va a la columna derecha; la galería, a la izquierda y fija
   mientras se baja; y cada sección de la landing (reseñas en adelante) ocupa las dos
   columnas, debajo. Este script solo marca con clases; todo lo demás es CSS.
   El celular no cambia: todas las reglas están dentro de @media (min-width: 990px). */
(function () {
  if (!/kinso-parches-detox/.test(location.pathname)) return;
  var DESDE = 990;
  var css = "@media (min-width:" + DESDE + "px){"
    /* html y body traen overflow-x:hidden (para que lo "a sangre" no genere scroll lateral), y eso
       rompe el position:sticky de la galería; "clip" corta igual pero no crea contenedor de scroll */
    + "html.kd,html.kd body{overflow-x:clip!important;overflow-y:visible!important}"
    /* la grilla */
    + "html.kd .product{display:grid!important;grid-template-columns:minmax(0,1.1fr) minmax(0,1fr);column-gap:64px;row-gap:0;align-items:start}"
    + "html.kd .product>.product__media-wrapper{grid-column:1;grid-row:1/span 30;width:auto!important;max-width:none!important;margin:0!important;padding:0!important;position:relative;align-self:stretch}"
    /* lo fijo va en la galería de ADENTRO: Chrome limita el sticky al padre, y el padre (la celda
       de la grilla, estirada) termina donde termina la zona de compra. Puesto en la celda, la
       galería quedaba fija sobre toda la landing */
    + "html.kd .product__media-wrapper>media-gallery{position:sticky!important;top:20px!important}"
    /* p9TE4L fuerza cada foto a 100vw (pensado para el carrusel del celular): en desktop, al ancho de la columna */
    + "html.kd .product__media-wrapper .product__media-list>.product__media-item{width:100%!important;max-width:100%!important}"
    /* las fotos de la galería son cuadradas (1024): la caja hereda el 4:5 de la media original
       y las recortaba a los costados; en el celular p9TE4L ya la hace cuadrada, acá también */
    + "html.kd .product__media-wrapper .product__media-list .media{padding-top:100%!important}"
    + "html.kd .product>.product__info-wrapper,html.kd .product__info-container,html.kd .kd-big{display:contents!important}"
    + "html.kd .product__info-container>*,html.kd .kd-big>*:not(.kd-full){grid-column:2;min-width:0;max-width:560px!important;width:100%!important}"
    + "html.kd .kd-big>.kd-full{grid-column:1/-1;max-width:none!important}"
    + "html.kd .kd-big>.kd-full:first-of-type,html.kd .kd-primera{margin-top:72px!important}"
    /* la zona de compra: un poco más de aire y los packs sin achicarse */
    + "html.kd .product__title{margin-top:8px}"
    + "html.kd #linax-bundle-selector{max-width:560px!important}"
    /* secciones que en el celular eran de la columna: centradas y con ancho de lectura */
    + "html.kd .kd-big>.kd-full.kd-angosta{max-width:760px!important;margin-left:auto!important;margin-right:auto!important;width:100%!important}"
    + "html.kd .kd-big>.kd-full.kd-ancha{max-width:1100px!important;margin-left:auto!important;margin-right:auto!important;width:100%!important}"
    /* reseñas "lo que nos escriben": a sangre pero con el contenido al ancho de la página, 3 por vista */
    + "html.kd .krev{padding-left:max(24px,calc((100vw - 1100px) / 2))!important;padding-right:max(24px,calc((100vw - 1100px) / 2))!important;box-sizing:border-box!important}"
    + "html.kd .krev-c{flex:0 0 calc((100% - 20px) / 3)!important}"
    /* pie: tres columnas en vez de una tira angosta */
    + "html.kd .kf-inner,html.kd .kf-bottom{max-width:1100px!important;width:auto!important;margin-left:auto!important;margin-right:auto!important;padding-left:24px;padding-right:24px}"
    + "html.kd .kf-inner{display:grid!important;grid-template-columns:1.25fr 1fr 1fr;column-gap:64px;row-gap:22px;align-items:start}"
    + "html.kd .kf-brand{grid-area:1/1/2/2}html.kd .kf-nav{grid-area:2/1/3/2}html.kd .kf-club{grid-area:1/2/3/3}"
    + "html.kd .kf-pagos{grid-area:1/3/2/4}html.kd .kf-envio{grid-area:2/3/3/4}html.kd .kf-contacto{grid-area:3/3/4/4}"
    + "html.kd .kf-inner>*{margin-top:0!important}"
    + "}";
  var s = document.createElement("style"); s.id = "kinso-desktop-css"; s.textContent = css;
  document.head.appendChild(s);

  var COMPRA = ["linax-bundle-selector", "linax-garantia", "linax-form-faqs"];
  function marcar() {
    if (window.innerWidth < DESDE) { document.documentElement.classList.remove("kd"); return false; }
    var sel = document.getElementById("linax-bundle-selector");
    if (!sel) return false;
    var big = sel.parentElement;
    big.classList.add("kd-big");
    var faq = document.getElementById("linax-form-faqs"), despues = false, primera = true;
    for (var i = 0; i < big.children.length; i++) {
      var c = big.children[i];
      if (c === faq) { despues = true; continue; }
      if (!despues || COMPRA.indexOf(c.id) >= 0 || c.tagName === "PRODUCT-FORM" || c.tagName === "SCRIPT" || c.tagName === "STYLE") continue;
      c.classList.add("kd-full");
      if (primera) { c.classList.add("kd-primera"); primera = false; }
      /* las que no eran "a sangre" en el celular: ancho de lectura, centradas */
      if (!c.classList.contains("kd-medida")) {
        c.classList.add("kd-medida");
        if (/^(linax-higado|linax-comp-table)$/.test(c.id)) {
          c.classList.add("kd-angosta");
          /* si la sección tiene fondo propio, el fondo sigue a sangre aunque el contenido vaya a 760 */
          var bg = getComputedStyle(c).backgroundColor;
          if (bg && bg !== "transparent" && !/rgba\(.*,\s*0\)$/.test(bg)) {
            c.style.boxShadow = "0 0 0 100vmax " + bg; c.style.clipPath = "inset(0 -100vmax)";
          }
        }
        if (c.id === "linax-testimonios") c.classList.add("kd-ancha");
      }
    }
    document.documentElement.classList.add("kd");
    return !!faq;
  }
  /* los bloques de la landing montan con setInterval y algunos tarde: se remarca un rato */
  var n = 0, t = setInterval(function () { marcar(); if (++n > 60) clearInterval(t); }, 300);
  window.addEventListener("resize", marcar);
})();
